import React, { useCallback, useContext } from 'react'
import { CartoonStyles, NewAffiliationDashboardStyles } from './Style'
import { Img, LightButton, SmallSpace, Space } from 'styles/GlobalStyle'
import { Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { app } from 'router/routes'
import { affiliationSetupHooks } from '.'
import { AffiliationSetupContext } from './AffiliationSetupContext'
import { isEmpty } from 'lodash'

const NewAffiliationDashboard = () => {
    const { affiliation, handleAlert } = useContext(AffiliationSetupContext)
    const navigate = useNavigate()

    const trainingCards = affiliationSetupHooks.useAffiliationSetupCards()

    const goAffiliationTab = useCallback((tabIndex) => {
        if (affiliation) {
            handleAlert(false)
            navigate(`${app.affiliations}/${affiliation.id}`, {
                state: {
                    tabIndex
                }
            })
        }
    }, [affiliation])

    return (
        <NewAffiliationDashboardStyles>
            <div className='header'>
                <div className='affiliation-name-title'>{`בית ספר ${affiliation?.name || ""}`}</div>
                <div className='sub-title'>{"ברוכים הבאים למערכת Go Read!"}</div>
                <div className='sub-title'>{"לפניכם שלושה שלבים לפני תחילת ביצוע המבדקים. "}</div>
            </div>

            <div className='step-cards'>
                <div className='cards'>
                    {trainingCards.map(card =>
                        <Grid item sm={12} xl={4} key={card.id} container justifyContent="center">
                            <div className='card' style={{ margin: '15px' }}>
                                <div className='step-number'>{`שלב ${card.id}`}</div>
                                <SmallSpace />
                                <div className='card-title'>{card.title}</div>
                                <div className='card-description'>{card.description}</div>
                                <Space />
                                {isEmpty(affiliation) ||
                                    <LightButton
                                        size="small"
                                        label={card.button}
                                        action={() => goAffiliationTab(card.tabIndex)}
                                    />}
                                <Space />
                                <CartoonStyles {...card.imgSize}>
                                    <Img src={card.img} />
                                </CartoonStyles>
                            </div>
                        </Grid>
                    )}
                </div>
            </div>
        </NewAffiliationDashboardStyles>
    )
}

export default NewAffiliationDashboard